import { Component, Prop, Vue } from 'vue-property-decorator';
import MixinChart, { TAcquisitionMode, TMode } from '@/plugins/podolib/services/helper/mixins/chart/index';

import { TAcquisition } from '@/plugins/podolib/services/entities/EntityPatients';
import { get } from 'lodash';

@Component
export default class MixinChartEvolution extends MixinChart {
  @Prop({ required: true }) protected acquisitions!: TAcquisition[];
  @Prop({ default: 'standard' }) protected type!: TAcquisitionMode;
  @Prop({ default: 'absolute' }) protected mode!: TMode;

  chartHeight = 350;
  lineType: 'line' | 'spline' = 'spline';
  rangeType: 'arearange' | 'areasplinerange' = 'arearange';
  shapeOpacity = 0.3;
  markerType: 'circle' | 'square' | 'diamond' | 'triangle' | 'triangle-down' = 'circle';

  get isWalkAnalysis() {
    return this.type === 'standard';
  }

  get isAbsolute() {
    return this.mode === 'absolute';
  }

  getLeft(val: any, parameter?: string) {
    if (parameter) {
      return this.isWalkAnalysis
        ? get(val, 'computed_data').left?.aggregates?.[parameter] || { avg: 0, std: 0 }
        : get(val, 'computed_data.aggregates').left?.[parameter] || { avg: 0, std: 0 };
    } else {
      return this.isWalkAnalysis
        ? get(val, 'computed_data').left?.aggregates || { avg: 0, std: 0 }
        : get(val, 'computed_data.aggregates').left || { avg: 0, std: 0 };
    }
  }
  getRight(val: any, parameter?: string) {
    if (parameter) {
      return this.isWalkAnalysis
        ? get(val, 'computed_data').right?.aggregates?.[parameter] || { avg: 0, std: 0 }
        : get(val, 'computed_data.aggregates').right?.[parameter] || { avg: 0, std: 0 };
    } else {
      return this.isWalkAnalysis
        ? get(val, 'computed_data').right?.aggregates || { avg: 0, std: 0 }
        : get(val, 'computed_data.aggregates').right || { avg: 0, std: 0 };
    }
  }
}

@Component
export class MixinChartGroupEvolution extends Vue {
  @Prop({ required: true }) protected acquisitions!: TAcquisition[];
  @Prop({ default: 'standard' }) protected type!: TAcquisitionMode;
  @Prop({ default: 'absolute' }) protected mode!: TMode;
}
